import React, { useState, useEffect } from "react";
import { Row, Col } from "antd";

import MasterName from "../../components/mastName/master"

export default function DeviceHome(prop) {
  return (
    <div>
      <Row>
        <Col span={24}><MasterName /></Col>
      </Row>
    </div>
  );
}
